import Kanban from '../images/assets/Kanban.png';
import Quiz from '../images/assets/quiz.png';
import Comments from '../images/assets/comments.png';
import URLShortener from '../images/assets/url-shortener.png';
import RestCountries from '../images/assets/rest-countries.png';
import Ecommerce from '../images/assets/sneaker.PNG';
import IPAddress from '../images/assets/ip-address.PNG';
import WeatherApp from '../images/assets/weather-app.PNG';
import RoomFurnitures from '../images/assets/room-furnitures.PNG';
import JobListing from '../images/assets/job-listings.png';
import StaticChatApp from '../images/assets/chat-app.PNG';
import Todos from '../images/assets/todos.PNG';

export const projects = [
	{
		title: 'Kanban Task Management',
		description:
			'Kanban task management web app allows you to create, read, edit and delete boards and tasks. Mark subtasks as complete and move tasks between columns.',
		image: Kanban,
		tags: ['Next.js', 'TypeScript', 'Redux', 'Ant Design', 'Firebase', 'Git'],
		sourceCode: 'https://github.com/mmajudith/kanban-task-management',
		visit: 'https://kanban-task-management-zeta.vercel.app/',
		id: 0,
	},
	{
		title: 'Quiz App',
		description:
			'A website that allow the user to create, edit and take a quiz and see the result immediately after the quiz. the user can also delete and add questions and options to the created quiz.',
		image: Quiz,
		tags: [
			'ReactJs',
			'Reduxjs/toolkit',
			'TailwindCss',
			'Firebase',
			'React-toastify',
			'Framer-motion',
			'Git',
		],
		sourceCode: 'https://github.com/mmajudith/quiz-app',
		visit: 'https://quiz-app-mmajudith.vercel.app',
		id: 1,
	},
	{
		title: 'Rest Countries',
		description:
			'Rest countries is a website that display all the countries in the world and details about them like name, populations etc. You can click on each country to view the details about the country.',
		image: RestCountries,
		tags: [
			'Next.js',
			'TailwindCss',
			'TypeScript',
			'Axios',
			'rest-countries-api',
			'Git',
		],
		sourceCode: 'https://github.com/mmajudith/rest-countries',
		visit: 'https://rest-countries-mmajudith.vercel.app',
		id: 2,
	},
	{
		title: 'Interactive Comments',
		description:
			'Interactive comments section is an app that allow user to create, update, delete and reply a comment.',
		image: Comments,
		tags: [
			'ReactJs',
			'TailwindCss',
			'Redux',
			'TypeScript',
			'LocalStorage',
			'Git',
		],
		sourceCode: 'https://github.com/mmajudith/interactive-comments-section',
		visit: 'https://inter-comments-section.netlify.app',
		id: 3,
	},
	{
		title: 'URL Shortener',
		description:
			'URL shortening landing page that provides input field for users to shorten their long link and see their results immediately, below the form after submiting the long link.',
		image: URLShortener,
		tags: ['NextJS', 'TailwindCss', 'Axios', 'shrtcode API', 'Git'],
		sourceCode: 'https://github.com/mmajudith/url-shortener',
		visit: 'https://url-shortener-mmajudith.vercel.app',
		id: 4,
	},
	{
		title: 'E-commerce product',
		description: `A website that sells universal sneakers. You can toggle the products, \n
                    add and remove sneakers from cart, click on the cart to view your added products with the price.`,
		image: Ecommerce,
		tags: [
			'ReactJs',
			'Typescript',
			'TailwindCss',
			'Redux',
			'React/Redux',
			'Git',
		],
		sourceCode: 'https://github.com/mmajudith/ecommerce-product',
		visit: ' https://ecommerce-product-indol.vercel.app/',
		id: 5,
	},
	{
		title: 'IP Address Tracker',
		description: 'A web application that is use to track an IP address.',
		image: IPAddress,
		tags: ['ReactJs', 'Css', 'Leaflet', 'Axios', 'Iplify', 'Git'],
		sourceCode: 'https://github.com/mmajudith/ip-address-tracker',
		visit: 'https://mmajudith.github.io/ip-address-tracker/',
		id: 6,
	},
	{
		title: 'Weather App',
		description:
			'A web application that is used to check the weather condition of any city.',
		image: WeatherApp,
		tags: ['ReactJs', 'Css', 'Axios', 'PWA', 'Git'],
		sourceCode: 'https://github.com/mmajudith/weather-app-pwa',
		visit: 'https://sleepy-wright-75d644.netlify.app',
		id: 7,
	},
	{
		title: 'Room Home Page',
		description: 'A room furniture landing page website.',
		image: RoomFurnitures,
		tags: ['ReactJs', 'SASS', 'Git'],
		sourceCode: 'https://github.com/mmajudith/room-home-page',
		visit: 'https://mmajudith.github.io/room-home-page/',
		id: 8,
	},
	{
		title: 'Job Listings',
		description:
			'A website that display the list of companies that needs a software developer to hire.',
		image: JobListing,
		tags: ['HTML', 'CSS/SASS', 'JavaScript', 'Git'],
		sourceCode: 'https://github.com/mmajudith/static-job-listings-master',
		visit: 'https://mmajudith.github.io/static-job-listings-master/',
		id: 9,
	},
	{
		title: 'Todos App',
		description:
			'A web application that allows you to add, search and remove your todos.',
		image: Todos,
		tags: ['HTML', 'CSS', 'JavaScript', 'Bootstrap 4', 'Git'],
		sourceCode: 'https://github.com/mmajudith/todos',
		visit: 'https://mmajudith.github.io/todos/',
		id: 10,
	},
	{
		title: 'Chat App Illustration',
		description:
			'A Chat application interface built with html and css to test css skill.',
		image: StaticChatApp,
		tags: ['HTML', 'CSS', 'Git'],
		sourceCode: 'https://github.com/mmajudith/chat-app-css-illustration',
		visit: 'https://mmajudith.github.io/chat-app-css-illustration/',
		id: 11,
	},
];
